import SEOInfo from './SEOInfo';

export default SEOInfo;
